module.exports = __webpack_public_path__ + "img/hk.34db9dfd.png";